// extracted by mini-css-extract-plugin
module.exports = {"tabs__content":"styles_tabs__content__6ULK2","pulse":"styles_pulse__rzthj","jump":"styles_jump__jqtQq","wiggle":"styles_wiggle__Qtn7I"};